import { render } from "./NavbarNew.vue?vue&type=template&id=5b5e7bcd&scoped=true"
import script from "./NavbarNew.vue?vue&type=script&lang=js"
export * from "./NavbarNew.vue?vue&type=script&lang=js"

import "./NavbarNew.vue?vue&type=style&index=0&id=5b5e7bcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5e7bcd"]])

export default __exports__